import { createAction } from "redux-act";

export const setExportConfig = createAction("Set export config");
